import { Col, Row, message, Carousel } from "antd";
import { useEffect, useState, useRef } from "react";
import moment from "moment";
import { GetAllNewsContent } from "./ajax";
import { NavLink } from "react-router-dom";

export function NewsActiveHome(props) {
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);
  const imgbox = useRef();
  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
  }, []);
  const goto = (index) => {
    imgbox && imgbox.current.goTo(index, false);
  };
  const reload = async () => {
    let res = await GetAllNewsContent({ pageSize: 500 });
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      setData(res.data.filter((i) => i.show * 1 === 1));
    }
  };
  useEffect(() => {
    reload();
  }, []);
  let settings = {
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    speed: 300,
    dots: false,
  };

  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <div className="kkmagic-pc">
          <div className="kkparttitle">
            <div className="tomiddlemargin">
              <div
                style={{ left: `${index * 480 + 240}px` }}
                className="activearrow"
              ></div>
              <div
                className={`${index === 0 ? "tocompress" : ""}`}
                onClick={() => {
                  goto(0);
                }}
              >
                <div>KK 幼儿园</div>
                <div>KK KINDERGARTEN</div>
              </div>
              <div
                className={`${index === 1 ? "tocompress" : ""}`}
                onClick={() => {
                  goto(1);
                }}
              >
                <div>KK 绘画社</div>
                <div>KK ART CLUB</div>
              </div>
              <div
                className={`${index === 2 ? "tocompress" : ""}`}
                onClick={() => {
                  goto(2);
                }}
              >
                <div>KK 训练营</div>
                <div>KK DRAWING CAMP</div>
              </div>
            </div>
          </div>
          <div className="kkpartcontent">
            <Carousel
              {...settings}
              ref={imgbox}
              beforeChange={(from, to) => {
                setIndex(to);
              }}
            >
              <KKkinderPart />
              <KKmagicPart />
              <KKAllumi />
            </Carousel>
          </div>
        </div>

        <div className="NewsActive-pc">
          <NewsActivity data={data} {...props} />
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="kkmagic-ph">
          <KkMagicSchoolph
            index={index}
            setIndex={setIndex}
            settings={settings}
          />
          <div className="newsactive-title">
            <div>
              <div>
                NEWS <span>&</span> EVENTS
              </div>
              <div>
                近期新闻<span></span>活动
              </div>
            </div>
          </div>
        </div>
        <div>
          <NewsActivityPh data={data} reload={reload} {...props} />
        </div>
      </Col>
    </Row>
  );
}

function KkMagicSchoolph(props) {
  let { settings } = props;
  const [page, setPage] = useState(0);
  const imgphslide = useRef();
  const goto = (index) => {
    imgphslide && imgphslide.current.goTo(index, false);
  };
  return (
    <div className="kkmagic-box">
      <div className="kkbox">
        <div className="kkboxcontent">
          <div
            style={{ left: `${page * 2.5 + 1.25}rem` }}
            className="activearrowph"
          ></div>
          <div
            className={`${page === 0 ? "tocompressph" : ""}`}
            onClick={() => {
              goto(0);
            }}
          >
            <div>KK幼儿园</div>
            <div>KK KINDERGARTEN</div>
          </div>
          <div
            className={`${page === 1 ? "tocompressph" : ""}`}
            onClick={() => {
              goto(1);
            }}
          >
            <div>KK绘画社</div>
            <div>KK ART CLUB</div>
          </div>
          <div
            className={`${page === 2 ? "tocompressph" : ""}`}
            onClick={() => {
              goto(2);
            }}
          >
            <div>KK训练营</div>
            <div>KK DRAWING CAMP</div>
          </div>
        </div>
      </div>
      <div className="kkboxslide">
        <Carousel
          {...settings}
          ref={imgphslide}
          beforeChange={(from, to) => {
            setPage(to);
          }}
        >
          <KKkinderPartPh />
          <KKmagicCupPartPh />
          <KKAlumniPartPh />
        </Carousel>
      </div>
    </div>
  );
}
function KKkinderPartPh(props) {
  return (
    <div className="kkkinderpartph">
      <div className="suit-for-news-text-ph">
        <div className="suit-for-news-text1">
          <span>最适合新手的免费学习社区 !</span>
        </div>
        <div className="suit-for-news-text2">
          <span>
            和小伙伴一起交流·共同练习、打牢基本功·建立对绘画的正确认知·树立绘画好习惯
          </span>
        </div>
        <NavLink to="/notes/1" className="kk-btn-ph">
          <div>
            <span>立即加入</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
function KKmagicCupPartPh(props) {
  return (
    <div className="kkkinderpartph2">
      <div className="suit-for-news-text-ph">
        <div className="suit-for-news-text1">
          <span>进阶练习 !</span>
        </div>
        <div className="suit-for-news-text2">
          <span>
            进阶练习社群，更有助教掉落分享，欢迎来和同学们一起团练打卡，练习速写、人体！
          </span>
        </div>
        <NavLink to="/notes/5" className="kk-btn-ph">
          <div>
            <span>查看更多</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
function KKAlumniPartPh(props) {
  return (
    <div className="kkkinderpartph3">
      <div className="suit-for-news-text-ph">
        <div className="suit-for-news-text1">
          <span>49天零基础抓型入门 !</span>
        </div>
        <div className="suit-for-news-text2">
          <span>
            从软件操作开始，逐步掌握绘画基本功，达到手眼一致，随心临摹，实现绘画入门~
          </span>
        </div>
        <NavLink to="/notes/6" className="kk-btn-ph">
          <div>
            <span>查看更多</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
function NewsActivityPh(props) {
  let { data, reload } = props;

  return (
    <div className="newsactive-ph">
      <div className="newsactivity-title">
        <div>
          <div className="trangle-active-ph">
            <div>全部</div>
            <div>All EVENTS</div>
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div className="newsactivity-content-ph">
        <div>
          <NewsContent reload={reload} data={data} {...props} />
          <div
            className="more-btn"
            onClick={() => {
              props.history.push(`/notes`);
            }}
          >
            MORE {">>"}
          </div>
        </div>
      </div>
      <div className="newsactivity-footer-ph"></div>
    </div>
  );
}

function NewsContent(props) {
  let { data } = props;
  const newsColorType = [
    "",
    "typegreen",
    "typepurple",
    "typeyellow",
    "typegray",
    "typepink",
    "typegreenblack",
    "typegreenblue",
  ];
  return (
    <div className="news-content-box">
      {data.map((i) => {
        let arr = [
          "",
          "KK幼儿园",
          "KK魔法杯",
          "三宝活动室",
          "KK头条站",
          "KK绘画社",
          "KK训练营",
          "KK图书馆",
        ];
        return (
          <div
            key={i.id}
            className="news-content-box-ph"
            onClick={() => {
              props.history.push(`/newsdetail/${i.id}`, i);
            }}
          >
            <div>{moment(i.createTime * 1000).format("YYYY .MM .DD")}</div>
            <div className="tocolor">
              <div className={`${newsColorType[i.newsType]}`}>
                {arr[i.newsType]}
              </div>
              <div>{i.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function NewsActivity(props) {
  let { data } = props;

  return (
    <div className="newsactivity-box">
      <div className="newsimg">
        <div className="newsactivity-box-title">
          <div className="news-title-text">
            <span>
              NEWS <span className="and-icon">&</span> EVENTS
            </span>
            <span>近期新闻活动</span>
          </div>
        </div>
        <div className="news-divide-title">
          <div className="four-title">
            <div className="trangle-active">
              <span>全部</span>
              <span>All EVENTS</span>
            </div>
          </div>
        </div>
        <div className="newsactivity-content">
          <div>
            <NewsALL data={data} {...props} />
          </div>
          <div
            onClick={() => {
              props.history.push(`/notes`);
            }}
          >
            MORE {">>"}
          </div>
        </div>
      </div>
      <div className="news-bottom"></div>
    </div>
  );
}

function NewsALL(props) {
  let { data } = props;
  const newsColorType = [
    "",
    "typegreen",
    "typepurple",
    "typeyellow",
    "typegray",
    "typepink",
    "typegreenblack",
    "typegreenblue",
  ];
  return (
    <div className="newsall-box">
      {data.map((i) => {
        let arr = [
          "",
          "KK幼儿园",
          "KK魔法杯",
          "三宝活动室",
          "KK头条站",
          "KK绘画社",
          "KK训练营",
          "KK图书馆",
        ];
        return (
          <div
            className="newsall-title"
            key={i.id}
            onClick={() => {
              props.history.push(`/newsdetail/${i.id}`, i);
            }}
          >
            <div>{moment(i.createTime * 1000).format("YYYY .MM .DD")}</div>
            <div className="newsallnewstype">
              <div className={`${newsColorType[i.newsType]}`}>
                {arr[i.newsType]}
              </div>
              <div>{i.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function KKkinderPart(props) {
  return (
    <div className="kkkinderbg">
      <div className="kkmaigic-tocenter">
        <div className="suit-for-news-text">
          <div className="suit-for-news-text1">
            <span>最适合新手的免费学习社区 !</span>
          </div>
          <div className="suit-for-news-text2">
            <span>
              和小伙伴一起交流·共同练习、打牢基本功·建立对绘画的正确认知·树立绘画好习惯
            </span>
          </div>

          {/* <div className="suit-for-news-text3"><span>COMMUNICATE WITH FRIENDS . PRACTICE TOGETHER, LAY A SOLID FOUNDATION . ESTABLISH A CORRECT UNDERSTANDING OF PAINTING . ESTABLISH A GOOD HABIT OF PAINTING</span></div> */}
        </div>
        <div className="kkkinder"></div>
        <NavLink to="/notes/1" className="pckkbtnlink">
          <div className="pc-kk-btn">
            <span>立即加入</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}

function KKmagicPart(props) {
  return (
    <div className="kkmagicbg">
      <div className="kkmaigic-tocenter">
        <div className="suit-for-news-text">
          <div className="suit-for-news-text1">
            <span>进阶练习 ！</span>
          </div>
          <div className="suit-for-news-text2">
            <span>
              进阶练习社群，更有助教掉落分享，欢迎来和同学们一起团练打卡，练习速写、人体！
            </span>
          </div>

          {/* <div className="suit-for-news-text3"><span>COMMUNICATE WITH FRIENDS . PRACTICE TOGETHER, LAY A SOLID FOUNDATION . ESTABLISH A CORRECT UNDERSTANDING OF PAINTING . ESTABLISH A GOOD HABIT OF PAINTING</span></div> */}
        </div>
        <div className="kkkinder2"></div>
        <NavLink to="/notes/5" className="pckkbtnlink">
          <div className="pc-kk-btn">
            <span>查看更多</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
function KKAllumi(props) {
  return (
    <div className="kkalumibg">
      <div className="kkmaigic-tocenter">
        <div className="suit-for-news-text">
          <div className="suit-for-news-text1">
            <span>49天零基础抓型入门！</span>
          </div>
          <div className="suit-for-news-text2">
            <span>
              从软件操作开始，逐步掌握绘画基本功，达到手眼一致，随心临摹，实现绘画入门~
            </span>
          </div>

          {/* <div className="suit-for-news-text3"><span>COMMUNICATE WITH FRIENDS . PRACTICE TOGETHER, LAY A SOLID FOUNDATION . ESTABLISH A CORRECT UNDERSTANDING OF PAINTING . ESTABLISH A GOOD HABIT OF PAINTING</span></div> */}
        </div>
        <div className="kkkinder3"></div>
        <NavLink to="/notes/6" className="pckkbtnlink">
          <div className="pc-kk-btn">
            <span>查看更多</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
